<div
  class="item"
  [class.selected]="iu.isSelected(image)"
  [ngClass]="[iu.mode, iu.color || '']"
  (click)="iu.changeImage(image)"
>
  @if (!iu.isDefault(image)) {
    <img [src]="image?.urls.thumb" alt="thumb" />
  } @else {
    <ng-container *ngTemplateOutlet="iu.defaultDirective?.vc"></ng-container>
  }
</div>

@if (iu.isSelected(image)) {
  <mat-icon class="item-selected-icon zef-icon-large" color="primary">bullet_check</mat-icon>
} @else {
  @if (!iu.isDefault(image)) {
    <div class="item-menu" [matMenuTriggerFor]="menu" (menuClosed)="isMenuOpen = false">
      <button mat-icon-button>
        <mat-icon>more</mat-icon>
      </button>
      <mat-menu #menu>
        <button mat-menu-item class="zef-menu-item-alert" (click)="iu.removeImage(image)" i18n>Delete</button>
      </mat-menu>
    </div>
  }
}
